import React, { forwardRef } from 'react'

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | any
  alt: string
  width?: number | string
  height?: number | string
  fill?: boolean
  quality?: number | string
  priority?: boolean
  loading?: 'lazy' | 'eager'
  placeholder?: 'blur' | 'empty'
  blurDataURL?: string
  unoptimized?: boolean
  objectFit?: React.CSSProperties['objectFit']
  objectPosition?: React.CSSProperties['objectPosition']
}

const Image = forwardRef<HTMLImageElement, ImageProps>(function ImageCompat(
  {
    src,
    alt,
    width,
    height,
    fill,
    quality,
    priority,
    loading,
    placeholder,
    blurDataURL,
    unoptimized,
    objectFit,
    objectPosition,
    style,
    ...rest
  },
  ref
) {
  const imgSrc = typeof src === 'object' && src !== null ? src.src || src.default || '' : src
  const imgStyle: React.CSSProperties = {
    ...style,
    ...(fill ? { position: 'absolute', height: '100%', width: '100%', inset: '0px' } : {}),
    ...(objectFit ? { objectFit } : {}),
    ...(objectPosition ? { objectPosition } : {})
  }

  return (
    <img
      ref={ref}
      src={imgSrc}
      alt={alt || ''}
      width={fill ? undefined : width}
      height={fill ? undefined : height}
      loading={priority ? 'eager' : loading || 'lazy'}
      style={imgStyle}
      {...rest}
    />
  )
})

export default Image
